import { useMedicareUrl } from 'hooks/useMedicareUrl'

export const useLegacyPremiumsHref = () => {
  return useMedicareUrl(
    'https://www.medicare.gov/mbp/PremiumInformation.aspx',
    'https://www.medicare.gov/mbp/PremiumInformation.aspx?Lang=es-mx'
  )
}
